export default {
  list_currencies: ['USD', 'CAD', 'IDR', 'GBP', 'CHF', 'SGD', 'INR', 'MYR', 'JPY', 'KRW'],
  detail_currencies: {
    USD: 'United States Dollar',
    CAD: 'Canadian Dollar',
    IDR: 'Indonesian Rupiah',
    GBP: 'British Pound',
    CHF: 'Swiss Franc',
    SGD: 'Singapore Dollar',
    INR: 'Indian Rupee',
    MYR: 'Malaysian Ringgit',
    JPY: 'Japanese Yen',
    KRW: 'Korean Won',
  },
};



// WEBPACK FOOTER //
// ./src/utils/constant.js